import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Card, Divider, Link } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';

const AccessibilityStatement = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Accessibility Statement
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid 
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >
              <Typography component={'p'} variant='body1'  marginBottom={3}>
                The Office of Campaign and Political Finance is committed to ensuring digital accessibility for all users, 
                including individuals with disabilities. We aim to provide a user experience that is inclusive, usable, and 
                compliant with accessibility standards.
              </Typography>
              <Typography variant="subtitle1" gutterBottom fontWeight={550}>
                Accessibility Features
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={3}>
                Our website strives to meet the <Link href="https://www.w3.org/TR/WCAG21/" target="_blank" rel="noopener noreferrer">Web Content Accessibility Guidelines (WCAG) 2.1</Link>, Level AA. 
                The website is designed to be easy to navigate, readable, and usable for all users, including people with disabilities.
              </Typography>
              <Typography variant="subtitle1" gutterBottom fontWeight={550}>
                Ongoing Improvements
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={3}>
                  We continuously monitor and update our website to improve accessibility. 
                  While we strive for compliance, some areas may still have accessibility challenges.
              </Typography>
              <Typography variant="subtitle1" gutterBottom fontWeight={550}>
                Feedback
              </Typography>
              <Typography component={'p'} variant='body1'  marginBottom={2}>
                  If you encounter any accessibility barriers or have suggestions, please contact us:
              </Typography>
               <ul>
                    <li><b>Email</b>: ocpf@mass.gov</li>
                    <li><b>Phone</b>: 617-979-8300</li>
                </ul>
                <Typography component={'p'} variant='body1'  marginBottom={3}>
                  We welcome your feedback and are committed to addressing accessibility concerns promptly.
                </Typography>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default AccessibilityStatement;